<template>
    <v-row class="room-activity-report-container-day">
        <v-col cols="12" class="text-center">
            <h1> BTG Utah Daily Husbandry Report - {{day.format($constants.DATE_FORMAT_NO_TIME)}}</h1>
        </v-col>
        <v-col cols="12">
            <v-data-table
                :headers="aliveBySpeciesHeaders"
                :items="aliveBySpeciesAsArray"
                hide-default-footer
            >
                <template  v-slot:item="props">
                    <tr>
                        <td v-for="(header, i) in aliveBySpeciesHeaders" :key="i" class="text-center">
                            {{props.item[header.value]}}
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-col>
        <v-col cols="12">
            <HusbandryRoomActivityReportDayRoom
                v-for="(room) in includedRoomsWithData"
                :key="room.RoomID"
                :room="room"
                :drawerData="dailyHusbandryByUserAndDrawer[room.RoomText] || {}"
                :observationAndOccurrenceData="observationsAndOccurrences[room.RoomText] || {}"
                :aliveInRoom="aliveByRoom.ByRoomName[room.RoomText]"
                :aliveInRoomBySpeciesData="aliveByRoomAndSpecies.ByRoomName[room.RoomText] || {}"
                :extractionData="extractionData[room.RoomText] || {}"
            >
            </HusbandryRoomActivityReportDayRoom>
        </v-col>
    </v-row>
</template>

<script>

import moment from "moment";

import HusbandryRoomActivityReportDayRoom from "@/components/reporting/HusbandryRoomActivityReportDayRoom.vue";

export default {
    components: {
        HusbandryRoomActivityReportDayRoom
    },
    props: [
        // This has been disabled in the initial lint setup - if you are working on this page please determine the correct type for these properties
        //eslint-disable-next-line
        "index",
        // This has been disabled in the initial lint setup - if you are working on this page please determine the correct type for these properties
        //eslint-disable-next-line
        "data"
    ],
    data() {
        return {
            
        }
    },
    computed: {
        day() {
            return moment(this.data.DayList[this.index]);
        },
        aliveBySpecies() {
            return this.data.AliveBySpeciesList[this.index];
        },
        aliveBySpeciesAsArray() {
            const data = [];

            data.push(this.aliveBySpecies);

            return data;
        },
        aliveBySpeciesHeaders() {
            if (!this.aliveBySpecies || !this.aliveBySpecies.IncludedSpecies || this.aliveBySpecies.IncludedSpecies.length <= 0) {
                return [];
            }

            const headers = [];

            headers.push({
                text: "Total Specimens",
                value: "TotalSpecimens",
                sortable: false,
                align: "center"
            });

            for (let i=0; i<this.aliveBySpecies.IncludedSpecies.length; i++) {
                const header = this.aliveBySpecies.IncludedSpecies[i];

                headers.push({
                    text: header,
                    value: header,
                    sortable: false,
                    align: "center"
                });
            }

            return headers;
        },
        aliveByRoomAndSpecies() {
            return this.data.AliveByRoomAndSpeciesList[this.index];
        },
        aliveByRoom() {
            return this.data.AliveByRoomList[this.index];
        },
        dailyHusbandryByUserAndDrawer() {
            return this.data.DailyHusbandryByUserAndDrawerList[this.index];
        },
        observationsAndOccurrences() {
            return this.data.ObservationsAndOccurrencesList[this.index];
        },
        extractionData() {
            return this.data.DailyExtractionList[this.index];
        },
        includedRoomsWithData() {
            const includedRooms = [...this.dailyHusbandryByUserAndDrawer.IncludedRooms];

            const possibleExtraRooms = [...this.observationsAndOccurrences.IncludedRooms, ...this.extractionData.IncludedRooms];

            for (const newRoom of possibleExtraRooms) {
                if (includedRooms.findIndex(r => r.RoomID == newRoom.RoomID) < 0) {
                    includedRooms.push(newRoom);
                }
            }

            return includedRooms;
        }
    },
    methods: {
        
    },
    created() {

    }
}

</script>

<style lang="scss">

#app {
    .room-activity-report-container-day {
        margin-bottom: 20px;

        .room-activity-report-container-day-room {
            margin-top: 20px;
            
            .alive-in-room-by-species-container {
                margin-bottom: 20px;
            }

            .room-activity-report-container-day-room-user {
                margin-bottom: 10px;
            }
        }

        h1, h2 {
            color: black;
        }

        h3, h4, h5, h6 {
            color: var(--v-navigation-darken2);
        }

        .v-data-table {
            border-left: hidden;
            border-right: hidden;
            border-bottom: 1px double black; // double takes precedence over solid in border conflict resolution https://www.w3.org/TR/CSS2/tables.html#border-conflict-resolution

            li {
                list-style-type:none;
            }

            thead tr {
                background-color: var(--v-info-lighten1);
                font-weight: bold;
            }

            tr {
                background-color: var(--v-info-lighten4);
                border-bottom: none;
            }

            td, th {
                color: black;
                border-left: 1px ridge white;
                border-right: 1px ridge white;

                padding-left: 5px;
                padding-right: 5px;
            }

            td, th, tr {
                height: 30px;
            }
        }

        /* override styles for tables without a header row */
        .observations-occurrences-table-container {
            margin-top: 10px;

            .title-text {
                font-weight: bold;
            }

            tr:nth-of-type(even) {
                background-color: var(--v-info-lighten4);
            }

            tr:nth-of-type(odd) {
                background-color: var(--v-info-lighten1);
            }
        }
    }
}

</style>>